import Vue from "vue";
import CompanyService from "@/service/CompanyService";
import MenuRightSerivce from "@/service/MenuRightService";
import SweetAlertService from "@/service/SweetAlertService";
import StaffService from "@/service/StaffService";
import StaffEmploymentService from "@/service/StaffEmploymentService";
import StoreGetter from "@/constants/StoreGetter";
import { PayType } from "@/model/PayType";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import Setting from "@/constants/Settings";
import PayTypeService from "@/service/PayTypeService";
import DocumentTemplateService from "@/service/DocumentTemplateService";
import PayTypeValidation from "./S082100-PayTypeValidation.js";
import Paginate from "vuejs-paginate";
import { GlobalMixin } from "@/common/mixin/GlobalMixin";
var payTypeObj = new PayTypeValidation();
export default {
    name: "payType",
    mounted() {
        console.log(this.vErrors)
        payTypeObj.payTypeValidation();
        this.assignRights();
        this.getAllPayType();
        this.getSalaryPayTypes();
        this.getSysVarList();
    },
    components: {
        paginate: Paginate,
    },
    data: () => ({
        ...GlobalMixin,
        menuRights: { allRights: {}, rightsForThisMenu: {} },
        menuId: Setting.MenuID.S_PayType,
        dictEnum: dictEnum,
        payType: new PayType(),
        isEditMode: false,
        payTypeList: [],
        selectedPayType: new PayType(),
        salaryPayTypes: [],
        sysVarList: [],
    }),
    computed: {
        t() {
            return t;
        },
        user() {
            return this.$store.getters[StoreGetter.user];
        },
        isBexAc() {
            let show = false;
            const result = Setting.SysParams.BexAccount;
            const list = this.$store.getters[StoreGetter.sysParams];
            const find = list.find((x) => x.ParamCode == result);
            if (find) {
                if (find.ParamVal.toLowerCase() === this.user.UserID.toLowerCase()) {
                    show = true
                }
            }
            return show
        },
        sysVars() {
            const list = this.sysVarList;
            return list;
        }
    },
    methods: {
        hasRight(key, menuId) {
            if (Object.keys(this.menuRights.allRights).length === 0) {
                return false;
            } else {
                return MenuRightSerivce.hasRightInMenu(
                    this.menuRights.allRights,
                    menuId ? menuId : this.menuId,
                    key
                );
            }
        },
        assignRights() {
            this.menuRights.allRights = this.$store.getters[StoreGetter.sysMenu];
            this.menuRights.rightsForThisMenu = this.menuRights.allRights.find(
                x => x.MenuID == this.menuId
            );
        },
        getSalaryPayTypes() {
            const res = [
                {
                    value: "M",
                    label: "M"
                },
                {
                    value: "MXS",
                    label: "MXS"
                },
                {
                    value: "H",
                    label: "H"
                },
            ]
            this.salaryPayTypes = res
        },

        async getSysVarList() {
            const obj = {};
            const response = await DocumentTemplateService.getAllSysVar(obj);
            if (response.data.IsSuccess) {
                this.sysVarList = response.data.Data;
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },

        async getAllPayType() {
            var self = this;
            var obj = {}
            const response = await PayTypeService.getAllPayType(obj);
            if (response.data.IsSuccess) {
                self.payTypeList = response.data.Data;
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },

        clickSysVar(sysVar) {
            this.payType.Formula += sysVar.SysVarCode
        },
        deleteMultiplePayTypePopup: function () {
            if (this.selectedPayType.PayTypeCode) {
                $('#deletePayTypeListModel').modal('show');
            }
            else {
                SweetAlertService.warning("Warn", t.t(dictEnum.MSG_SelectDeleteRecord));
            }
        },
        async deleteMultiplePayType() {
            var self = this;
            $('#deletePayTypeListModel').modal('hide');
            const obj = {
                model: self.selectedPayType,
            };
            const response = await PayTypeService.deletePayType(obj);
            if (response.data.IsSuccess) {
                SweetAlertService.success("Success", response.data.Message);
                self.resetPayType();
                await self.getAllPayType();
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },
        OnPayTypeSelect: function (model) {
            this.selectedPayType = JSON.parse(JSON.stringify(model));
        },
        addPayType: function () {
            var self = this;
            $('#payTypeModel').modal('show');
            self.isEditMode = false;
            self.payType = new PayType();
            self.$validator.reset();
            self.vErrors.clear();
        },
        async savePayTypeDetail(obj) {
            var self = this;
            const response = await PayTypeService.addPayType(obj);
            if (response.data.IsSuccess) {
                SweetAlertService.success("Success", response.data.Message);
                self.resetPayType();
                await self.getAllPayType();
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },
        async editPayType(obj) {
            var self = this;
            const response = await PayTypeService.updatePayType(obj);
            if (response.data.IsSuccess) {
                SweetAlertService.success("Success", response.data.Message);
                self.resetPayType();
                await self.getAllPayType();
            } else {
                SweetAlertService.warning("Warn", response.data.Message);
            }
        },
        async savePayType() {
            var self = this;
            self.$validator.validateAll().then(result => {
                if (result) {
                    $('#payTypeModel').modal('hide');
                    const obj = {
                        model: self.payType
                    };
                    self.savePayTypeDetail(obj)
                }
            });
        },
        async editPayTypeDetail() {
            var self = this;
            self.isEditMode = true;
            if (self.selectedPayType.PayTypeCode != "") {
                self.payType = this.selectedPayType;
                self.$validator.reset();
                self.vErrors.clear();
                $('#payTypeModel').modal('show');
            }
            else {
                SweetAlertService.warning("Warn", t.t(dictEnum.MSG_SelectEditRecord));
            }
        },
        resetPayType: function () {
            var self = this;
            self.isEditMode = false;
            self.payType = new PayType();
            self.selectedPayType = new PayType();
            self.$validator.reset();
            self.vErrors.clear();
        },
        closePayTypePopup: function () {
            var self = this;
            self.isEditMode = false;
            self.payType = new PayType();
            self.selectedPayType = new PayType();
            self.$validator.reset();
            self.vErrors.clear();
            $('#payTypeModel').modal('hide');
        },
    }
}



// WEBPACK FOOTER //
// ./src/components/S080000-Setup/S082100-PayType/S082100-PayType.js